webpackJsonp([86270741702289],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dale/Documents/cp-website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/Users/dale/Documents/cp-website/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dale/Documents/cp-website/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/templates/CaseStudy/index.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _presets$Desktop, _presets$Tablet, _presets$Mobile, _after, _blockquote, _section, _presets$Desktop2, _presets$Tablet2, _presets$Mobile2, _before, _section2, _column, _column2, _caseStudyStat, _section3, _caseStudy, _caseStudyInner, _caseStudyInnerImage, _caseStudyInnerDescri, _caseStudyStat2, _styles;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _presets = __webpack_require__("./src/utils/presets.js");
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _globalStyles = __webpack_require__("./src/utils/global-styles.js");
	
	var _globalStyles2 = _interopRequireDefault(_globalStyles);
	
	var _button = __webpack_require__("./src/components/button.js");
	
	var _prismicDom = __webpack_require__("./node_modules/prismic-dom/dist/prismic-dom.min.js");
	
	var _prismicDom2 = _interopRequireDefault(_prismicDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CaseStudy = function (_React$Component) {
	  _inherits(CaseStudy, _React$Component);
	
	  function CaseStudy() {
	    _classCallCheck(this, CaseStudy);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  CaseStudy.prototype.render = function render() {
	
	    var caseStudy = this.props.data.prismicDocument;
	    var caseStudies = this.props.data.allPrismicDocument.edges;
	
	    return Glamor.createElement(
	      'div',
	      { itemScope: true, itemType: 'http://schema.org/Article' },
	      Glamor.createElement(
	        _reactHelmet.Helmet,
	        { title: _prismicDom2.default.RichText.asText(caseStudy.data.company_name) },
	        Glamor.createElement('meta', { name: 'description', content: _prismicDom2.default.RichText.asText(caseStudy.data.company_description) }),
	        Glamor.createElement('meta', { property: 'og:type', content: 'website' }),
	        Glamor.createElement('meta', { property: 'og:title', content: _prismicDom2.default.RichText.asText(caseStudy.data.company_name) + " | CarePlanner" }),
	        Glamor.createElement('meta', { property: 'og:description', content: _prismicDom2.default.RichText.asText(caseStudy.data.company_description) }),
	        Glamor.createElement('meta', { name: 'twitter:title', content: _prismicDom2.default.RichText.asText(caseStudy.data.company_name) + " | CarePlanner" }),
	        Glamor.createElement('meta', { name: 'twitter:description', content: _prismicDom2.default.RichText.asText(caseStudy.data.company_description) })
	      ),
	      Glamor.createElement(
	        'div',
	        { css: [styles.section1, { '::before': { backgroundImage: 'url(' + caseStudy.data.large_image.url + ')' } }] },
	        Glamor.createElement(
	          'div',
	          { css: _globalStyles2.default.container },
	          Glamor.createElement(
	            'h5',
	            null,
	            'Case Study'
	          ),
	          Glamor.createElement(
	            'h1',
	            { itemProp: 'name' },
	            _prismicDom2.default.RichText.asText(caseStudy.data.company_name)
	          ),
	          Glamor.createElement(
	            'blockquote',
	            null,
	            '"',
	            _prismicDom2.default.RichText.asText(caseStudy.data.quote),
	            '"'
	          ),
	          Glamor.createElement(
	            'div',
	            { css: _globalStyles2.default.quoteHeader },
	            Glamor.createElement('span', { css: _globalStyles2.default.placeholder }),
	            Glamor.createElement(
	              'span',
	              { css: _globalStyles2.default.quoteAuthor },
	              caseStudy.data.quote_author,
	              ' - '
	            ),
	            Glamor.createElement(
	              'span',
	              { css: _globalStyles2.default.quoteCompany, itemProp: 'about' },
	              ' ',
	              _prismicDom2.default.RichText.asText(caseStudy.data.company_name)
	            )
	          )
	        )
	      ),
	      Glamor.createElement(
	        'div',
	        { css: styles.section2 },
	        Glamor.createElement(
	          'div',
	          { css: _globalStyles2.default.container },
	          Glamor.createElement(
	            'div',
	            { css: styles.column1, itemProp: 'articleBody' },
	            Glamor.createElement(
	              'div',
	              { itemProp: 'articleSection' },
	              Glamor.createElement(
	                'h2',
	                null,
	                'The Company'
	              ),
	              Glamor.createElement('div', { dangerouslySetInnerHTML: { __html: _prismicDom2.default.RichText.asHtml(caseStudy.data.company_description) } })
	            ),
	            Glamor.createElement(
	              'div',
	              { itemProp: 'articleSection' },
	              Glamor.createElement(
	                'h2',
	                null,
	                'The Problem'
	              ),
	              Glamor.createElement('div', { dangerouslySetInnerHTML: { __html: _prismicDom2.default.RichText.asHtml(caseStudy.data.problem) } })
	            ),
	            Glamor.createElement(
	              'div',
	              { itemProp: 'articleSection' },
	              Glamor.createElement(
	                'h2',
	                null,
	                'The Solution'
	              ),
	              Glamor.createElement('div', { dangerouslySetInnerHTML: { __html: _prismicDom2.default.RichText.asHtml(caseStudy.data.solution) } })
	            ),
	            Glamor.createElement(
	              'div',
	              { itemProp: 'articleSection' },
	              Glamor.createElement(
	                'h2',
	                null,
	                'The Results'
	              ),
	              Glamor.createElement('div', { dangerouslySetInnerHTML: { __html: _prismicDom2.default.RichText.asHtml(caseStudy.data.results) } })
	            )
	          ),
	          Glamor.createElement(
	            'div',
	            { css: styles.column2 },
	            Glamor.createElement(
	              'div',
	              { css: styles.caseStudyStat },
	              Glamor.createElement(
	                'div',
	                { css: styles.caseStudyStatFigure },
	                caseStudy.data.key_stat_figure
	              ),
	              Glamor.createElement(
	                'div',
	                { css: styles.caseStudyStatDescription },
	                caseStudy.data.key_stat_text
	              )
	            ),
	            Glamor.createElement(
	              'blockquote',
	              null,
	              '"',
	              _prismicDom2.default.RichText.asText(caseStudy.data.quote),
	              '"'
	            ),
	            Glamor.createElement(
	              'div',
	              { css: _button.buttonGroupStyle.vertical },
	              Glamor.createElement(
	                _gatsbyLink2.default,
	                { css: [_button.buttonStyle.button, _button.buttonStyle.filled, _button.buttonStyle.large], style: { display: 'block' }, to: '/contact-us' },
	                'Book a demo'
	              )
	            )
	          )
	        )
	      ),
	      Glamor.createElement(
	        'div',
	        { css: styles.section3, itemScope: true, itemType: 'http://schema.org/ItemList' },
	        Glamor.createElement(
	          'div',
	          { css: _globalStyles2.default.container },
	          Glamor.createElement(
	            'h2',
	            { onClick: function onClick() {
	                return (0, _gatsbyLink.navigateTo)('/case-studies');
	              } },
	            'More Case Studies'
	          ),
	          caseStudies.map(function (caseStudy, i) {
	            return Glamor.createElement(
	              'div',
	              { css: styles.caseStudy, key: i, onClick: function onClick() {
	                  return (0, _gatsbyLink.navigateTo)(caseStudy.node.fields.permalink);
	                }, itemProp: 'itemListElement' },
	              Glamor.createElement(
	                'div',
	                { css: styles.caseStudyInner },
	                Glamor.createElement('img', { css: styles.caseStudyInnerImage, src: caseStudy.node.data.large_image.url, alt: 'Quote from {PrismicDOM.RichText.asText(caseStudy.node.data.company_description)}' }),
	                Glamor.createElement(
	                  'h3',
	                  { itemProp: 'name' },
	                  _prismicDom2.default.RichText.asText(caseStudy.node.data.company_name)
	                ),
	                Glamor.createElement('div', { css: styles.caseStudyInnerDescription, dangerouslySetInnerHTML: { __html: _prismicDom2.default.RichText.asHtml(caseStudy.node.data.summary) } }),
	                Glamor.createElement(
	                  _gatsbyLink2.default,
	                  { to: caseStudy.node.fields.permalink },
	                  'Read Case Study...'
	                )
	              ),
	              Glamor.createElement(
	                'div',
	                { css: styles.caseStudyStat },
	                Glamor.createElement(
	                  'div',
	                  { css: styles.caseStudyStatFigure },
	                  caseStudy.node.data.key_stat_figure
	                ),
	                Glamor.createElement(
	                  'div',
	                  { css: styles.caseStudyStatDescription },
	                  caseStudy.node.data.key_stat_text
	                )
	              )
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return CaseStudy;
	}(_react2.default.Component);
	
	exports.default = CaseStudy;
	;
	
	var styles = (_styles = {
	  section1: (_section = {
	    position: 'relative'
	  }, _section[_presets2.default.Desktop] = {
	    padding: '100px'
	  }, _section[_presets2.default.Tablet] = {
	    padding: '100px'
	  }, _section[_presets2.default.Mobile] = {
	    marginBottom: '60px',
	    padding: '70px 50px'
	  }, _section['::before'] = {
	    content: '""',
	    position: 'absolute',
	    top: '0',
	    left: '0',
	    width: '100%',
	    height: '150%',
	    opacity: '.4',
	    zIndex: '-1',
	    backgroundRepeat: 'no-repeat',
	    backgroundPosition: 'right top',
	    backgroundSize: 'auto 100%'
	  }, _section['::after'] = (_after = {
	    content: '""',
	    position: 'absolute',
	    top: '0',
	    left: '0',
	    height: '150%',
	    right: '0',
	    zIndex: '-1',
	    backgroundRepeat: 'no-repeat',
	    backgroundSize: 'cover'
	  }, _after[_presets2.default.Desktop] = (_presets$Desktop = {
	    backgroundImage: '-webkit-linear-gradient(right,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 70%)'
	  }, _presets$Desktop['backgroundImage'] = '-o-linear-gradient(left,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 70%)', _presets$Desktop['backgroundImage'] = '-moz-linear-gradient(left,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 70%)', _presets$Desktop['backgroundImage'] = 'linear-gradient(to left, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 70%)', _presets$Desktop), _after[_presets2.default.Tablet] = (_presets$Tablet = {
	    backgroundImage: '-webkit-linear-gradient(right,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 70%)'
	  }, _presets$Tablet['backgroundImage'] = '-o-linear-gradient(left,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 70%)', _presets$Tablet['backgroundImage'] = '-moz-linear-gradient(left,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 70%)', _presets$Tablet['backgroundImage'] = 'linear-gradient(to left, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 70%)', _presets$Tablet), _after[_presets2.default.Mobile] = (_presets$Mobile = {
	    backgroundImage: '-webkit-linear-gradient(right,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 90%)'
	  }, _presets$Mobile['backgroundImage'] = '-o-linear-gradient(left,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 90%)', _presets$Mobile['backgroundImage'] = '-moz-linear-gradient(left,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 90%)', _presets$Mobile['backgroundImage'] = 'linear-gradient(to left, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 90%)', _presets$Mobile), _after), _section['& blockquote'] = (_blockquote = {}, _blockquote[_presets2.default.Desktop] = {
	    margin: '20px 0',
	    maxWidth: '60%'
	  }, _blockquote[_presets2.default.Tablet] = {
	    margin: '20px 0'
	  }, _blockquote[_presets2.default.Mobile] = {
	    margin: '10px 0'
	  }, _blockquote), _section),
	  section2: (_section2 = {}, _section2[_presets2.default.Desktop] = {
	    padding: '0 100px 100px 100px'
	  }, _section2[_presets2.default.Tablet] = {
	    padding: '0 50px'
	  }, _section2[_presets2.default.Mobile] = {
	    marginBottom: '60px',
	    padding: '0 20px'
	  }, _section2['::before'] = (_before = {
	    content: '""',
	    position: 'absolute',
	    top: 0,
	    left: 0,
	    height: '150%',
	    right: 0,
	    zIndex: -1,
	    backgroundRepeat: 'no-repeat',
	    backgroundSize: 'cover'
	  }, _before[_presets2.default.Desktop] = (_presets$Desktop2 = {
	    backgroundImage: '-webkit-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 75%)'
	  }, _presets$Desktop2['backgroundImage'] = '-o-linear-gradient(bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 75%)', _presets$Desktop2['backgroundImage'] = '-moz-linear-gradient(bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 75%)', _presets$Desktop2['backgroundImage'] = 'linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 75%)', _presets$Desktop2), _before[_presets2.default.Tablet] = (_presets$Tablet2 = {
	    backgroundImage: '-webkit-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 75%)'
	  }, _presets$Tablet2['backgroundImage'] = '-o-linear-gradient(bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 75%)', _presets$Tablet2['backgroundImage'] = '-moz-linear-gradient(bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 75%)', _presets$Tablet2['backgroundImage'] = 'linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 75%)', _presets$Tablet2), _before[_presets2.default.Mobile] = (_presets$Mobile2 = {
	    backgroundImage: '-webkit-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 70%)'
	  }, _presets$Mobile2['backgroundImage'] = '-o-linear-gradient(bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 70%)', _presets$Mobile2['backgroundImage'] = '-moz-linear-gradient(bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 70%)', _presets$Mobile2['backgroundImage'] = 'linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 70%)', _presets$Mobile2), _before), _section2),
	  column1: (_column = {}, _column[_presets2.default.Desktop] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '60%',
	    width: '60%',
	    margin: '0 1%',
	    '& p': {
	      fontSize: '18px',
	      lineHeight: '35px',
	      marginBottom: '40px'
	    }
	  }, _column[_presets2.default.Tablet] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '60%',
	    width: '60%',
	    margin: '0 1%',
	    '& p': {
	      fontSize: '18px',
	      lineHeight: '35px',
	      marginBottom: '40px'
	    }
	  }, _column[_presets2.default.Mobile] = {
	    maxWidth: '90%',
	    width: '90%',
	    margin: '5%'
	  }, _column),
	  column2: (_column2 = {}, _column2[_presets2.default.Desktop] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '28%',
	    width: '28%',
	    margin: '0 5%'
	  }, _column2[_presets2.default.Tablet] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '28%',
	    width: '28%',
	    margin: '0 5%'
	  }, _column2[_presets2.default.Mobile] = {
	    maxWidth: '90%',
	    width: '90%',
	    margin: '5%'
	  }, _column2),
	  caseStudyStat: (_caseStudyStat = {
	    width: 'calc(100% - 40px)',
	    padding: '20px',
	    margin: '40px 0',
	    background: '#F4F8FC'
	  }, _caseStudyStat[_presets2.default.Desktop] = {
	    height: '108px',
	    maxHeight: '108px'
	  }, _caseStudyStat[_presets2.default.Tablet] = {
	    height: '108px',
	    maxHeight: '108px'
	  }, _caseStudyStat),
	  caseStudyStatFigure: {
	    fontSize: '36px',
	    color: '#4F739A',
	    textAlign: 'center',
	    margin: '10px 0'
	  },
	  caseStudyStatDescription: {
	    textAlign: 'center',
	    margin: '10px'
	  },
	  section3: (_section3 = {
	    background: '#F4F8FC'
	  }, _section3[_presets2.default.Desktop] = {
	    padding: '50px 100px'
	  }, _section3[_presets2.default.Tablet] = {
	    padding: '50px'
	  }, _section3[_presets2.default.Mobile] = {
	    padding: '10px 10px'
	  }, _section3['& h2'] = {
	    textAlign: 'center'
	  }, _section3['&:hover > * > div'] = {
	    opacity: .6
	  }, _section3['&:hover > * > div:hover'] = {
	    opacity: 1
	  }, _section3),
	  caseStudy: (_caseStudy = {}, _caseStudy[_presets2.default.Desktop] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '24%',
	    width: '24%',
	    margin: '4% .5% 0 .5%',
	    '-moz-transition': 'opacity .2s',
	    '-o-transition': 'opacity .2s',
	    '-webkit-transition': 'opacity .2s',
	    transition: 'opacity .2s'
	  }, _caseStudy[_presets2.default.Tablet] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '29%',
	    width: '29%',
	    margin: '4% 1.9% 0 1.9%'
	  }, _caseStudy[_presets2.default.Mobile] = {
	    maxWidth: '90%',
	    width: '90%',
	    margin: '5%'
	  }, _caseStudy),
	  caseStudyInner: (_caseStudyInner = {
	    width: 'calc(100% - 40px)',
	    padding: '20px',
	    marginBottom: '20px',
	    cursor: 'pointer'
	  }, _caseStudyInner[_presets2.default.Desktop] = {
	    maxHeight: '324px',
	    height: '324px'
	  }, _caseStudyInner[_presets2.default.Tablet] = {
	    maxHeight: '324px',
	    height: '324px'
	  }, _caseStudyInner),
	  caseStudyInnerImage: (_caseStudyInnerImage = {}, _caseStudyInnerImage[_presets2.default.Desktop] = {
	    width: '100%'
	  }, _caseStudyInnerImage[_presets2.default.Tablet] = {
	    width: '100%'
	  }, _caseStudyInnerImage[_presets2.default.Mobile] = {
	    display: 'none'
	  }, _caseStudyInnerImage),
	  caseStudyInnerDescription: (_caseStudyInnerDescri = {}, _caseStudyInnerDescri[_presets2.default.Desktop] = {
	    maxHeight: '141px',
	    overflow: 'hidden',
	    textOverflow: 'ellipsis'
	  }, _caseStudyInnerDescri[_presets2.default.Tablet] = {
	    maxHeight: '141px',
	    overflow: 'hidden',
	    textOverflow: 'ellipsis'
	  }, _caseStudyInnerDescri)
	}, _styles['caseStudyStat'] = (_caseStudyStat2 = {
	  width: 'calc(100% - 40px)',
	  padding: '20px',
	  background: '#F4F8FC',
	  cursor: 'pointer'
	}, _caseStudyStat2[_presets2.default.Desktop] = {
	  height: '108px',
	  maxHeight: '108px',
	  margin: '40px 0'
	}, _caseStudyStat2[_presets2.default.Tablet] = {
	  height: '108px',
	  maxHeight: '108px',
	  margin: '40px 0'
	}, _caseStudyStat2), _styles['caseStudyStatFigure'] = {
	  fontSize: '36px',
	  color: '#4F739A',
	  textAlign: 'center',
	  margin: '10px 0'
	}, _styles['caseStudyStatDescription'] = {
	  textAlign: 'center',
	  margin: '10px'
	}, _styles);
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-case-study-index-js-1b3a3a7d9e9854883757.js